export default __webpack_public_path__ + "static/media/thumbnail-02.c67f2cd3.png";